export default {"src":"/_next/static/media/MetaverseIcon.30375e80.svg","height":70,"width":130};